import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router';
import { api_postValueOrErrorMessage } from '../../Api/util';
import Content from '../Content';
import Footer from '../Footer';
import Header from '../Header';
import Main from '../Main';
import MenuMobile from '../MenuMobile';

const pages: any = {

}

const pagesIds = ["2257", "cgus", "dmca", "privacy", "join_us"];

function StaticPage() {
  const [current, setCurrent] = useState<null | string>(null);
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!params.id) return navigate("/");
    if (!pagesIds.includes(params.id)) return navigate("/");
    if (pages[params.id]) return setCurrent(pages[params.id]);
    api_postValueOrErrorMessage<{ content: string }>("website/appendix", { appendix: params.id }).then(e => {
      if (!e.error_message) {
        pages[params.id as string] = e.content;
        setCurrent(e.content);
      }
    });
  }, [params.id]);

  return (<>
    <Header />
    <Content>
      <Main>
        <div className=' max-w-5xl w-full m-auto my-0 flex flex-col gap-8 text-xs'>
          {current && <div className=' whitespace-pre-wrap' id="static-page" dangerouslySetInnerHTML={{ __html: current }}></div>}
        </div>
      </Main>
    </Content>
    <Footer />
    <MenuMobile />
  </>)
}

export default StaticPage